import { useState, useEffect } from 'react';
import { collection, query, where, orderBy, getDocs } from 'firebase/firestore';
import { firestore } from '../lib/firebaseConfig';
import Card from './Card';
import BlockTitle from './BlockTitle';
import VindicationList from './VindicationList';

const emailTypeLabels = {
  'invoice': 'Faktura',
  'payment_due': 'Wezwanie do zapłaty',
  'reminder': 'Przypomnienie',
  'reminder_day10': 'Przypomnienie (10 dni)',
  'reminder_day15': 'Przypomnienie (15 dni)',
  'vindication': 'Windykacja',
  'confirmation': 'Potwierdzenie płatności',
  'general': 'Email'
};

const CustomerEmailHistory = ({ flatId, customerId, flatCode }) => {
  const [emailHistory, setEmailHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEmailHistory = async () => {
      if (!flatId && !customerId) {
        setLoading(false);
        return;
      }

      try {
        const emailHistoryRef = collection(firestore, 'emailHistory');

        // Query by flatId (primary) or customerId (fallback)
        let q;
        if (flatId) {
          q = query(
            emailHistoryRef,
            where('flatId', '==', flatId),
            orderBy('sentAt', 'desc')
          );
        } else if (customerId) {
          q = query(
            emailHistoryRef,
            where('customerId', '==', customerId),
            orderBy('sentAt', 'desc')
          );
        }

        const snapshot = await getDocs(q);

        const emails = snapshot.docs.map(doc => {
          const data = doc.data();
          const sentAt = data.sentAt?.toDate?.() || new Date();

          return {
            id: doc.id,
            title: emailTypeLabels[data.type] || data.type || 'Email',
            email: data.to,
            price: data.invoiceNumber || `Rata ${data.paymentId ? '#' : ''}${data.paymentNumber || '-'}`,
            status: {
              type: data.status === 'sent' ? 'success' : 'failed',
              title: data.status === 'sent' ? 'Wysłano' : 'Błąd',
              date: sentAt.toLocaleDateString('pl-PL')
            },
            // Additional data for potential expansion
            subject: data.subject,
            hasAttachment: data.hasAttachment,
            daysOverdue: data.daysOverdue
          };
        });

        setEmailHistory(emails);
      } catch (error) {
        console.error('Error fetching customer email history:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchEmailHistory();
  }, [flatId, customerId]);

  return (
    <Card>
      <BlockTitle>
        Historia emaili {flatCode ? `- ${flatCode}` : ''}
      </BlockTitle>

      {loading ? (
        <div className="py-4">
          <div className="animate-pulse space-y-3">
            <div className="h-12 bg-gray-200 rounded"></div>
            <div className="h-12 bg-gray-200 rounded"></div>
            <div className="h-12 bg-gray-200 rounded"></div>
          </div>
        </div>
      ) : emailHistory.length > 0 ? (
        <>
          <p className="text-sm text-gray-500 mb-4">
            {emailHistory.length} {emailHistory.length === 1 ? 'email' : 'emaili'}
          </p>
          <VindicationList items={emailHistory} />
        </>
      ) : (
        <p className="text-sm text-gray-500 py-4">
          Brak wysłanych emaili dla tego klienta
        </p>
      )}
    </Card>
  );
};

export default CustomerEmailHistory;
